/**
 * Created by mac on 5/6/17.
 */

cleverapps.EVENTS = cleverappsEvents;

cleverapps.whenAllInitialized = function (callback) {
    if (cleverapps.allInitialized) {
        callback();
        return;
    }

    if (!cleverapps.__whenAllInitializedCallbacks) {
        cleverapps.__whenAllInitializedCallbacks = [];
    }
    cleverapps.__whenAllInitializedCallbacks.push(callback);
};

cleverapps.afterAllLoadingFinish = function () {
    cleverapps.allInitialized = true;

    cleverapps.timeStart = Date.now();

    const callbacks = cleverapps.__whenAllInitializedCallbacks;
    delete cleverapps.__whenAllInitializedCallbacks;

    callbacks && callbacks.forEach((callback) => callback());
};

cleverapps.afterResourceLoaded = function () {
    if (typeof document !== "undefined") {
        document.title = Messages.get(cleverapps.config.name);
    }

    if (LogTimeStart.active) {
        LogTimeStart.active.stop();
    }

    cleverapps.abExperiments.updateGroups();

    if (cleverapps.getRequestParameters().testLoadingTime) {
        cleverapps.notification.create("Loading finished", {
            debugInfo: true
        });
        return;
    }

    cleverapps.LocalizationManager.run();

    cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.APP_INITIALIZE);
    cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.RENDER_TYPE + (cc._renderType === cc.game.RENDER_TYPE_CANVAS ? "canvas" : "webgl"));
    ErrorHandler.logContextLostReloads();
    cleverapps.newVersionChecker.processVersionChange();

    if (cleverapps.dataLoader.localStorage.supported !== undefined) {
        cleverapps.metrics.logEvent(cleverapps.dataLoader.localStorage.supported ? `${cleverapps.EVENTS.DEBUG.LOCAL_STORAGE.OK}-initialized` : cleverapps.EVENTS.DEBUG.LOCAL_STORAGE.ERROR);
    }

    if (cleverapps.dataLoader.localStorage.supported === false) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.CLEARANCE.LOCALSTORAGE_UNSUPPORTED);
    }

    if (cleverapps.dataLoader.checksumMatch !== undefined) {
        cleverapps.metrics.logEvent(`${!cleverapps.dataLoader.checksumMatch ? cleverapps.EVENTS.DEBUG.LOCAL_STORAGE.ERROR : cleverapps.EVENTS.DEBUG.LOCAL_STORAGE.OK}-checksum`);
    }

    if (cleverapps.dataLoader.hadUserFromStart === false && connector.synchronizer.serverBetterOnFirstSync === true) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.LOCAL_STORAGE.CLEARED);
    }

    cleverapps.Shaders.initialize();

    cleverapps.flags.update();
    cleverapps.promoCodes = new PromoCodes();

    cc.renderer.assignedZStep = 1 / 100000;

    cleverapps.bannerAd = new BannerAd();

    cleverapps.fraudDetector = new FraudDetector();

    const updateMetrics = () => {
        cleverapps.user.updateMetrics();

        const payer = ["none", "weak", "medium", "whale", "bigwhale"][cleverapps.paymentsHistory.classify()] || "none";
        cleverapps.metrics.setPayer(payer);

        connector._metrics.setBaseParameters(cleverapps.metrics.getBaseParameters());
    };

    const updateCheater = () => {
        if (!cleverapps.user.cheater) {
            return;
        }

        connector.conversions.disable();
        connector._predictionManager.disable();
    };

    cleverapps.country.on("update", () => updateMetrics());
    cleverapps.paymentsHistory.onAddPaymentListeners.metrics = () => updateMetrics();
    cleverapps.environment.on("update", () => updateMetrics());
    cleverapps.settings.on("updateLanguage", () => updateMetrics());
    cleverapps.user.on("updateCheater", () => updateMetrics());

    if (typeof GameLevelHelper !== "undefined") {
        GameLevelHelper.GetMainInstance().on("changeLevel", () => updateMetrics());
    }

    updateMetrics();
    updateCheater();

    cleverapps.user.on("updateCheater", () => updateCheater());

    connector._metrics.start();

    cleverapps.metrics.sendEvents();

    PushHelper.start();

    cleverapps.focusManager.distract({
        focus: "afterAllLoadingFinish",
        actions: [
            function (f) {
                cleverapps.resolution.whenResolutionInitialized(cleverapps.waitNoMore(2000, f));
            },

            function (f) {
                cleverapps.afterAllLoadingFinish();

                cleverapps.userDelete.checkDeletion(f);
            },

            function (f) {
                if (cleverapps.loadedSnapshot && cleverapps.loadedSnapshot.scene) {
                    cleverapps.reloadSnapshotScene(cleverapps.loadedSnapshot.scene, () => {
                        const ads = cleverapps.loadedSnapshot.ads;
                        if (ads && ads.running) {
                            cleverapps.rewardedAdsManager.showInterstitial({
                                limit: AdsLimits.TYPES.INTERSTITIAL,
                                placement: AdsLimits.TYPES.INTERSTITIAL_INACTIVE
                            });
                        }
                        f();
                    });
                    return;
                }

                cleverapps.Plot.onStartup(f);
            }
        ]
    });
};

cleverapps.createGlobalObjects = function () {
    [cleverapps.importSnapshot,
        cleverapps.unitsDemoMode,
        cleverapps.personDemo,
        cleverapps.prefabEditorMode].forEach((debugObj) => {
        if (debugObj) {
            debugObj();
        }
    });

    cleverapps.bundleLoader = new BundleLoader();
    cleverapps.timeouts = new Timeouts();
    cleverapps.flags = new cleverapps.Flags();
    cleverapps.gameModes = new GameModes();
    cleverapps.eventBus = new cleverapps.EventEmitter();
    cleverapps.notification = new cleverapps.Notification();
    cleverapps.centerHint = new CenterHint();
    cleverapps.aims = new Aims();
    cleverapps.resolution = new ResolutionManager();

    cleverapps.metrics = new MetricsLogger();

    cleverapps.dataLoader.initialize();
    cleverapps.metrics.load();
    cleverapps.dataVersion.onLoad();

    cleverapps.syncedStorage = new SyncedStorage();
    cleverapps.dataSlots = new DataSlots();

    cleverapps.gameModes.load();
    cleverapps.instantTournament = new InstantTournament();
    cleverapps.scoreTracker = new ScoreTracker();
    cleverapps.gameManager = new GameManager();
    cleverapps.country = new Country();
    cleverapps.permissions = new UserPermissions();

    cleverapps.abExperiments = new ABExperiments();
    cleverapps.userDelete = new UserDelete();

    Products.initialize();
    Mission.initialize();

    Offers.initialize();
    VirtualProducts.initialize();
    RewardedAdOverlay.initialize();

    if (cleverapps.InitConfigByType[cleverapps.config.type]) {
        cleverapps.InitConfigByType[cleverapps.config.type]();
    }

    if (cleverapps.config.launch) {
        cleverapps.applyLaunchConfig();
    }

    if (connector.platform.oneOf(connector.G5WINDOWS) || cleverapps.flags.norest || cleverapps.config.importMode) {
        connector.synchronizer.disable();
    }

    cleverapps.playInTwoTabs = new PlayInTwoTabs();
    cleverapps.newVersionChecker = new NewVersionChecker();

    cleverapps.kpi = new KpiLogger();

    cleverapps.focusManager = new FocusManager();

    cleverapps.playSession = new PlaySession();

    cleverapps.persons = new PersonsLibrary();

    cleverapps.info = new cleverapps.Information();

    ExpHelper.Initialize();

    if (cleverapps.config.features.includes("game_level")) {
        GameLevelHelper.Initialize();
    }

    const isNewUser = cleverapps.dataLoader.haveSavedData() === false;

    if (isNewUser) {
        console.log("Creating new user");
        connector.synchronizer.reset();
    }

    cleverapps.paymentsLogic = new PaymentsLogic();
    cleverapps.settings = new cleverapps.Settings(isNewUser);

    cleverapps.user = levels.user = new levels.User(isNewUser);

    if (cleverapps.isKnockoutGame()) {
        cleverapps.knockoutGame = new KnockoutGame();
    }

    cleverapps.environment = new cleverapps.Environment();

    cleverapps.meta = new Meta();
    cleverapps.meta.load();

    cleverapps.consoleStream = new cleverapps.ConsoleStream();
    cleverapps.lazyAssets = new LazyAssets();

    cleverapps.userStatus = new UserStatus();

    cleverapps.scenes = new cleverapps.Scenes();

    cleverapps.skins = new cleverapps.SkinManager();
    cleverapps.shadow = new ShadowModel();
    cleverapps.loading = new LoadingModel();

    cleverapps.persist = new Persist();

    cleverapps.audio = new cleverapps.Audio();
    cleverapps.haptics = new Haptics();

    cleverapps.info.reportUserAgent();
    cleverapps.info.reportMaxTextureSize();
    cleverapps.info.reportSysLanguage();

    if (cleverapps.CrossPromo) {
        cleverapps.crossPromo = new cleverapps.CrossPromo();
    }

    cleverapps.friends = new Friends();
    cleverapps.requests = new Requests();
    cleverapps.activities = new Activities();

    cleverapps.paymentsHistory = new cleverapps.PaymentsHistory();

    cleverapps.userIdsHistory = new UserIdsHistory();

    cleverapps.serverFlags = new cleverapps.ServerFlags();

    cleverapps.boosters = new cleverapps.Boosters(isNewUser);

    cleverapps.forces = new Forces();

    levels.friendSorter = new FriendSorter();
    levels.friendRequests = new levels.FriendRequests();

    cleverapps.eventManager = new EventManager();
    cleverapps.missionManager = new MissionManager();
    cleverapps.personalBest = new PersonalBest();

    // should keep for client version compat
    cleverapps.competitionStatistics = new CompetitionStatistics();

    cleverapps.rewardedAdsManager = new RewardedAdsManager();

    cleverapps.offerManager = new OfferManager();

    if (WebWorker.IsAvailable()) {
        cleverapps.webWorker = WebWorker.Build();
    }

    cleverapps.exclamation = new Exclamation();

    cleverapps.pointerManager = new PointerManager();
    cleverapps.inputDispatcher = new InputDispatcher();

    if (cleverapps.config.debugMode) {
        cleverapps.createDebugGlobalObjects();
    }

    cleverapps.tooltipManager = new TooltipManager();

    cleverapps.appTracking = new AppTracking();

    cleverapps.tutorial = new Tutorial();

    if (!["merge", "merge2", "match3", "solitaire"].includes(cleverapps.config.type)) {
        cleverapps.tutorial.register(ButtonBoosterTutorial());
    }

    if (cleverapps.InitByType[cleverapps.config.type]) {
        cleverapps.InitByType[cleverapps.config.type](isNewUser);
    }

    if (isNewUser) {
        cleverapps.user.initializeNewPlayer();
    }

    cleverapps.config.features.forEach((feature) => {
        if (cleverapps.InitByFeature[feature]) {
            cleverapps.InitByFeature[feature](isNewUser);
        }
    });

    if (typeof TravelBook !== "undefined") {
        cleverapps.travelBook = new TravelBook();
    }

    cleverapps.subscription = new Subscription();
    cleverapps.vipAdsAdapter = new VipAdsAdapter();
    cleverapps.adsLimits = new AdsLimits();

    cleverapps.toolbar = new Toolbar();
    cleverapps.sideBar = new SideBar();
    cleverapps.menuBar = new MenuBar();

    if (typeof ExtraBar !== "undefined") {
        cleverapps.extraBar = new ExtraBar();
    }

    cleverapps.bots = new Bots();

    cleverapps.missionManager.init();

    if (cleverapps.travelBook) {
        cleverapps.travelBook.init();
    }

    cleverapps.offerManager.initialize();

    cleverapps.chat = new Chat();
    cleverapps.chat.init();

    cleverapps.availableMove = new AvailableMove();

    cleverapps.placements = new Placements();

    cleverapps.restoreProgress = new RestoreProgress();

    if (cleverapps.adminAccess) {
        cleverapps.adminAccess();
    }
};

cleverapps.InitConfigByType = {};

// Launch uses mission durations instead of weekday windows and shortens semaphore cooldowns to one second.
cleverapps.applyLaunchConfig = function () {
    Object.keys(Missions).filter((type) => typeof Missions[type] === "object").forEach((type) => {
        const missionData = Missions[type];
        if (missionData.schedule) {
            missionData.duration = `${MissionManager.scheduleDays(missionData.schedule)} days`;
            missionData.fixedFinish = true;
            delete missionData.schedule;
        }
        delete missionData.cooldown;
    });

    for (const name in Offers.TYPES) {
        const offerData = Offers[Offers.TYPES[name]];
        if (offerData) {
            delete offerData.schedule;
            delete offerData.cooldown;
        }
    }

    for (const semaphore in Mission.SEMAPHORE_COOLDOWNS) {
        Mission.SEMAPHORE_COOLDOWNS[semaphore] = "1 second";
    }
};

cleverapps.InitByType = {};
cleverapps.InitByFeature = {};

cleverapps.checkWebpSupport = function (done) {
    if (connector.platform.oneOf(connector.WECHAT) && connector.info.os === cc.sys.OS_ANDROID && connector.info.androidVersion >= 11) {
        cleverapps.config.webpSupport = true;
    }

    if (cleverapps.config.webpSupport !== undefined) {
        done();
        return;
    }

    if (connector.platform.oneOf(connector.WECHAT) && connector.info.os === cc.sys.OS_ANDROID) {
        const canvas = document.createElement("canvas");
        canvas.width = 1;
        canvas.height = 1;

        const context = canvas.getContext && canvas.getContext("2d");

        cleverapps.config.webpSupport = context && canvas.toDataURL("image/webp").startsWith("data:image/webp");

        done();

        return;
    }

    // https://developers.google.com/speed/webp/faq#how_can_i_detect_browser_support_for_webp
    const kTestImages = {
        lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
        lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
        alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA=="
    };

    let count = 0;
    let supported = 0;

    const callback = cleverapps.waitNoMore(5000, cleverapps.once(() => {
        cleverapps.config.webpSupport = supported === Object.keys(kTestImages).length;
        done();
    }));

    Object.keys(kTestImages).forEach((feature) => {
        cc.loader.loadImg(`data:image/webp;base64,${kTestImages[feature]}`, (status, img) => {
            const result = !status && img && (img.width > 0) && (img.height > 0);

            if (!result) {
                console.log(`webp ${feature} not supported`);
            }

            count++;
            if (result) {
                supported++;
            }

            if (!result || count === Object.keys(kTestImages).length) {
                callback();
            }
        });
    });
};

cleverapps.onStart = function () {
    console.log("game started");

    if (typeof document !== "undefined") {
        document.title = cleverapps.config.title;
    }

    const ruSources = ["vk", "ok", "mm", "yandex", "fotostrana", "labsystech", "rustore"];

    new ActionPlayer([
        function (f) {
            if (window.connectorInitStarted) {
                f();
            } else {
                window.onConnectorInitStart = f;
            }
        },

        function (f) {
            cleverapps.dataLoader = new DataLoader();
            cleverapps.dataVersion = new DataVersion();
            cleverapps.backwardCompatibility = new BackwardCompatibility();

            f();
        },

        function (f) {
            if (window.connectorInited) {
                f();
            } else {
                window.onConnectorInit = f;
            }
        },

        function (f) {
            const source = connector.info.source;
            const bothSources = ["android", "test"];
            if (!bothSources.includes(source)) {
                if (connector.config.payApiURL.startsWith("https://pay.labsystech.ru") && !ruSources.includes(source)
                    || connector.config.payApiURL.startsWith("https://pay.cleverappssg.com") && ruSources.includes(source)) {
                    cleverapps.throwAsync(`Incorrect ru source: ${source} href: ${window.location.href}`);
                }
            }

            if (cleverapps.config.debugMode && !cleverapps.isLocalhost() && !connector.info.isNative && window.location.protocol !== "https:") {
                throw `https required: ${window.location}`;
            }

            f();
        },

        (f) => {
            const enDeployment = cleverapps.config.enDeployment;
            const ruDeployment = cleverapps.config.ruDeployment;
            if (!enDeployment || !ruDeployment || connector.info.isNative || cleverapps.isLocalhost()
                || !cleverapps.config.debugMode || ruSources.includes(connector.info.source)
                || !window.location.href.startsWith(ruDeployment)) {
                f();
                return;
            }

            const url = enDeployment + window.location.pathname + window.location.search + window.location.hash;
            console.log(`ru deployment is for ru sources only, redirect ${connector.info.source} to ${url}`);
            window.location.replace(url);
        },

        function (f) {
            const enPublishUrl = cleverapps.config.enPublishUrl;
            if (!connector.platform.oneOf(connector.OK, connector.OKBRIDGE, connector.VK, connector.YANDEX, connector.MM, connector.FOTOSTRANA)
                || !enPublishUrl) {
                f();
                return;
            }

            const localStorage = connector.dataLoader.getLocalStorage();
            const prefix = cleverapps.config.name + connector.platform.getLocalStoragePrefix();
            const userData = localStorage.getItem(prefix);

            if (userData) {
                f();
                return;
            }

            cleverapps.getFrameData(enPublishUrl, {
                prefix,
                callback: function (data) {
                    data = data || {};

                    let frameUserId;
                    const userId = connector.platform.getUserID();

                    try {
                        if (data[prefix]) {
                            frameUserId = JSON.parse(data[prefix]).id;
                        }
                    } catch (e) {
                        console.error("parse frameUserId error", e);
                    }

                    console.log("frameUserId", frameUserId, "userId", userId);

                    if (!frameUserId || userId && !PlatformLogic.isTmpId(userId) && userId !== frameUserId) {
                        console.log(`ignore frame data - ${frameUserId} != ${userId}`);
                        f();
                        return;
                    }

                    for (const key in data) {
                        localStorage.setItem(key, data[key]);
                    }

                    f();
                }
            });
        },

        function (f) {
            cc.sys.isNative = connector.info.isNative;

            cleverapps.platformLogic = PlatformLogic.create();
            cleverapps.platformLogic.onInitialize();

            cleverapps.onPlatformStart();
            cleverapps.initServiceWorker();

            cc.ENABLE_CREATE_IMAGE_BITMAP = typeof createImageBitmap !== "undefined"
                && cc.sys.browserType !== cc.sys.BROWSER_TYPE_SAFARI
                && !connector.platform.oneOf(connector.IOS, connector.MACOS);

            f();
        }
    ]).play();
};

cleverapps.onPlatformStart = function () {
    cleverapps.createGlobalObjects();

    connector.platform.on("changeStatus", (status) => {
        cleverapps.metrics.logEvent((status === connector.STATUS_CONNECTED) ? cleverapps.EVENTS.PLATFORM.CONNECT : cleverapps.EVENTS.PLATFORM.DISCONNECT);
    });

    connector.platform.on("pendingRequestsFreeze", () => {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.PENDING_REQUESTS_FREEZE);
    });

    if (connector.social.isLoggedIn()) {
        const id = connector.platform.getUserID();
        cleverapps.SocialManager.onLogin({ oldId: id, newId: id });
    } else if (connector.social.isConnected() && !connector.platform.withTmpID() && !connector.platform.withDeviceID()) {
        cleverapps.SocialManager.onLogout();
    }

    connector.social.on("login", (params) => {
        cleverapps.SocialManager.onLogin(params);
    });

    connector.social.on("logout", () => {
        cleverapps.SocialManager.onLogout();
    });

    connector.player.on("changed", () => {
        cleverapps.SocialManager.onPlayerInfoChanged();
    });

    connector.platform.whenConnected(() => {
        if (connector.platform.oneOf(connector.SP_MOBAGE)) {
            cleverapps.resolution.setContainerPadding({
                bottom: 27
            });
        }

        if (connector.platform.oneOf(connector.MM) && !connector.info.isMobile) {
            if (window.outerHeight && window.innerHeight) {
                const maxH = window.outerHeight - 250;
                cleverapps.resolution.setupDesignResolution(cc.size(window.innerWidth, maxH));
            }
        }

        if (cleverapps.platformLogic.onConnected) {
            cleverapps.platformLogic.onConnected();
        }

        if (cleverapps.platformLogic.logPushes) {
            cleverapps.platformLogic.logPushes();
        }
    });

    cleverapps.platformLogic.initGameEvents();
    cleverapps.platformLogic.onStart();

    cleverapps.permissions.queuePermission((f) => {
        connector.ads.askPermission(f);
    });

    connector.ads.on("pluginChanged", () => {
        cleverapps.permissions.queuePermission((f) => {
            connector.ads.askPermission(f);
        });
    });

    cleverapps.permissions.queuePermission((f) => {
        if (connector.platform.oneOf(connector.CLEVERAPPS)) {
            cleverapps.abExperiments.whenGroupsUpdated(cleverapps.once(() => {
                if (cleverapps.abExperiments.getGroup(ABExperiments.Tests.clpushes) === "A") {
                    connector.notifications.askPermission(f);
                } else {
                    f();
                }
            }));
        } else {
            connector.notifications.askPermission(f);
        }
    });

    if (!cleverapps.user.isFirstSession()) {
        connector.platform.calcPromo((promo) => {
            if (!promo) {
                return;
            }

            cleverapps.metrics.logEvent(promo);
            if (cleverapps.user.isReturnedPlayer()) {
                cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.RETURNS + promo);
            }
        });

        if (connector.platform.oneOf(connector.INSTANT, connector.CLEVERAPPS, connector.LABSYSTECH)) {
            connector.platform.parsePayload((payload) => {
                const channel = payload && payload.channel;
                if (!channel) {
                    return;
                }

                cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.ENTRY_PAYLOAD, { details: payload });

                cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.RETARGET + channel);
            });
        }
    }

    let resumeFrame = -1000;
    const resumeFrameHandler = cleverapps.gameManager.on("resume", () => {
        resumeFrame = cc.director.getTotalFrames();
    });

    const checkCloudStorage = () => {
        if (!connector.cloudStorage.isEnabled()) {
            connector.synchronizer.disable();
        }
    };
    connector.cloudStorage.on("disable", checkCloudStorage);
    checkCloudStorage();

    new ActionPlayer([
        ActionPlayer.parallel([
            function (f) {
                cleverapps.abExperiments.initialize(cleverapps.waitNoMore(2000, LoaderScene.track("abExperiments", f)));
            },

            function (f) {
                if (cleverapps.user.isFirstSession()) {
                    cleverapps.user.calcChannel(cleverapps.waitNoMore(10000, LoaderScene.track("channel", f)));
                    connector.platform.on("attributionChanged", () => cleverapps.user.calcChannel());
                } else {
                    f();
                }
            },

            ActionPlayer.serial([
                (f) => cleverapps.waitSocialConnect(LoaderScene.track("social", f)),
                (f) => cleverapps.initSynchronizer(LoaderScene.track("sync", f))
            ]),

            function (f) {
                cleverapps.loadResources(f);
            }
        ])
    ]).play(() => {
        resumeFrameHandler.clear();

        cleverapps.silentIntro = cc.game.isPaused()
            || (cc.director.getTotalFrames() - resumeFrame) <= 60
            || cleverapps.loadedSnapshot
            || connector.platform.oneOf(connector.YOUTUBE) && cleverapps.user.getLevel() === 0;

        cleverapps.afterResourceLoaded();
    });
};

cleverapps.waitSocialConnect = function (done) {
    new ActionPlayer([
        (f) => {
            f = cleverapps.waitNoMore(5000, f);

            if (connector.social.isConnected()) {
                f();
            } else {
                connector.social.once("changeStatus", f);
            }
        },

        (f) => {
            if (connector.social.oneOf(connector.CRAZY) && connector.social.isConnected() && !connector.social.isLoggedIn()
                && !connector.platform.withTmpID() && !connector.platform.withDeviceID()) {
                connector.dataLoader.cleanAll();
                cleverapps.dataLoader.cleanAll();
                connector.dataLoader.setEnabled(false);
                cleverapps.dataLoader.setEnabled(false);
                window.location.reload();
                return;
            }

            f();
        }
    ]).play(done);
};

cleverapps.initSynchronizer = function (done) {
    if (connector.SYNC_STATUS.DISABLE === connector.synchronizer.status) {
        done();
        return;
    }

    if (["apple_000675.50cd3364a8b2449d8c721b0bf48c7af6.1224"].includes(connector.platform.getUserID())) {
        connector.synchronizer.on("checkSession:error", () => cleverapps.notification.create("sync checkSession failed"));
        connector.synchronizer.on("changeStatus", (status) => cleverapps.notification.create(`sync status ${status}`));

        connector.synchronizer.on("send:error", () => cleverapps.notification.create("sync send failed"));
        connector.synchronizer.on("send:success", cleverapps.accumulate(10000, () => cleverapps.notification.create("sync send success")));
    }

    connector.synchronizer.on("checkSession:error", () => cleverapps.placements.run(Placements.SYSTEM_FAULT));
    connector.synchronizer.on("checkSession:conflict", () => cleverapps.placements.run(Placements.SYSTEM_FAULT));
    connector.synchronizer.on("stream:error", (message, error) => cleverapps.throwAsync(message, error));

    connector.synchronizer.once("changeStatus", (status) => {
        if (connector.SYNC_STATUS.PULL === status) {
            connector.synchronizer.serverBetterOnFirstSync = true;
        }

        if (connector.SYNC_STATUS.ERROR === status && cleverapps.config.debugMode) {
            cleverapps.notification.create("Error saving progress");
        }
    });

    const firstSyncHandler = connector.synchronizer.on("changeStatus", (status) => {
        if (connector.SYNC_STATUS.IDLE === status) {
            console.log("first sync");

            if (connector.synchronizer.corrupted) {
                cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.CLEARANCE.CORRUPTED_SERVER_BETTER);
                delete connector.synchronizer.corrupted;
            }

            firstSyncHandler.clear();
        }
    });

    connector.synchronizer.on("changeStatus", (status) => {
        if (connector.SYNC_STATUS.IDLE === status && cleverapps.user.guest) {
            cleverapps.user.setGuest(false);
        }
    });

    let corrupted = cleverapps.dataLoader.checksumMatch === false;
    if ((cleverapps.isLocalhost() || cleverapps.config.debugMode) && !cleverapps.dataLoader.load(DataLoader.TYPES.TEST_CORRUPTED)) {
        corrupted = false;
    }

    const syncExperiment = connector.platform.oneOf(
        connector.YANDEX, 
        connector.MSSTART, 
        connector.TEST,
        connector.INSTANT, 
        connector.SAMSUNG,
        connector.VK,
        connector.ARKADIUM
    );

    new ActionPlayer([
        (f) => {
            if (syncExperiment) {
                cleverapps.abExperiments.initialize(cleverapps.waitNoMore(3000, f));
            } else {
                f();
            }
        },

        (f) => {
            if (syncExperiment) {
                cleverapps.abExperiments.updateGroups();

                if (cleverapps.abExperiments.getGroup(ABExperiments.Tests.platformsync) === "A") {
                    connector.config.platformsync = true;
                    connector.synchronizer.initialize();
                    connector.synchronizer.connect();
                }
            }

            f();
        },

        (f) => {
            connector.synchronizer.corrupted = corrupted;

            connector.synchronizer.start({
                getHeader: function () {
                    const header = SyncUtils.getHeader();

                    if (connector.synchronizer.corrupted) {
                        Object.assign(header, {
                            episode: 0,
                            level: 0,
                            progress: 0,
                            progressCompare: 0,
                            exp: 0,
                            repair: { room: 0, building: 0, stage: 0 }
                        });

                        if (["garden", "ladacha"].includes(cleverapps.config.name)) {
                            Object.assign(header, {
                                repair: { room: 0, building: 0, stage: 0 }
                            });
                        }
                    }

                    return header;
                },
                adapters: SyncAdapters,
                progressComparator: SyncUtils.progressComparator
            });

            f();
        },

        (f) => {
            const waitLonger = connector.social.isLoggedIn() && cleverapps.user.isFirstSession();
            f = cleverapps.waitNoMore(waitLonger ? 10000 : 3000, f);

            if (connector.SYNC_STATUS.INIT === connector.synchronizer.status) {
                connector.synchronizer.once("changeStatus", f);
            } else {
                f();
            }
        },

        (f) => {
            const data = connector.synchronizer.conflictData || {};

            if (connector.SYNC_STATUS.CONFLICT === connector.synchronizer.status) {
                connector.synchronizer.resolveConflict(data.localSnapshot, data.remoteSnapshot);
            }

            if (connector.SYNC_STATUS.PULL === connector.synchronizer.status && !connector.synchronizer.corrupted) {
                cleverapps.notification.create(Messages.get("Synchronizer.SyncInNotification"));
                connector.synchronizer.pull(data.newSession, data.remoteSnapshot);

                delete connector.synchronizer.conflictData;
            }

            f();
        }
    ]).play(done);
};

cleverapps.loadResources = function (done) {
    new ActionPlayer([
        ActionPlayer.parallel([
            ActionPlayer.serial([
                function (f) {
                    if (connector.platform.oneOf(connector.INSTANT, connector.SAMSUNG, connector.YANDEX)) {
                        connector.platform.whenConnected(LoaderScene.track("platform", f));
                    } else {
                        f();
                    }
                },

                function (f) {
                    const needChangeLanguage = (cleverapps.user.isFirstSession() || connector.platform.oneOf(connector.YANDEX)) && cleverapps.settings.language !== cleverapps.Settings.getDefaultLanguage() && !cleverapps.config.importMode;
                    if (needChangeLanguage) {
                        cleverapps.settings.setLanguage(cleverapps.Settings.getDefaultLanguage());

                        Messages.loadLanguage(cleverapps.settings.language, LoaderScene.track("language", f));
                    } else {
                        f();
                    }
                }
            ]),

            function (f) {
                cleverapps.checkWebpSupport(f);
            }
        ]),

        function (f) {
            if (cleverapps.snapshotToLoad) {
                cleverapps.loadSnapshot(cleverapps.snapshotToLoad, LoaderScene.track("snapshot", f));
                delete cleverapps.snapshotToLoad;
            } else {
                f();
            }
        },

        function (f) {
            cleverapps.resolution.setupResolutionScale();

            if (cleverapps.snapshotBar) {
                cleverapps.snapshotBar.createView();
            }

            if (cleverapps.git) {
                cleverapps.git.load();
            }

            if (connector.info.isNative && !cleverapps.config.webpSupport && resolutions[cleverapps.resolution.resolutionName].webp) {
                cleverapps.throwAsync("Error no webp supported");
            }

            const start = Date.now();

            const loaderScene = new LoaderScene(ResourceProcessor.calcProbablyNeed(), (() => {
                cleverapps.bundleLoader.loadBundles(ResourceProcessor.calcAlwaysNeed(), {
                    onSuccess: function () {
                        if (cleverapps.dataLoader.load(DataLoader.TYPES.THROWERROR)) {
                            cleverapps.dataLoader.remove(DataLoader.TYPES.THROWERROR);
                            throw "test error on load";
                        }

                        cleverapps.ConsoleStream.sendLoadingTime(`loaderScene ${Date.now() - start}ms`);

                        f();
                    }
                });
            }));

            cc.director.runScene(loaderScene);
            cc.director.setNextScene();
        }
    ]).play(done);
};

cleverapps.initServiceWorker = function () {
    if (window.location.pathname === "/" || !navigator.serviceWorker
        || cleverapps.snapshotToLoad && window.location.pathname.includes(cleverapps.snapshotToLoad)
        || !connector.platform.oneOf(
            connector.YANDEX,
            connector.VK,
            connector.OKBRIDGE,
            connector.OK,
            connector.MM,
            connector.FOTOSTRANA,
            connector.MSSTART,
            connector.CLEVERAPPS,
            connector.LABSYSTECH,
            connector.TEST,
            connector.CRAZY,
            connector.GDCOM,
            // connector.MOBAGE,
            // connector.SP_MOBAGE,
            connector.DRAUGIEM,
            connector.MSIX,
            connector.ARKADIUM
        )) {
        return;
    }

    let url = window.location.origin + window.location.pathname;

    if (url.endsWith(".html")) {
        url = url.substring(0, url.lastIndexOf("/") + 1);
    }
    url = url.replace(/(msstart\/|mspwa\/)$/, "");

    url = `${url}serviceworker.js`;

    // console.log("service worker url", url);

    navigator.serviceWorker.register(url).then(() => {
        console.log("Service worker registered");
    }).catch((error) => {
        console.error("Service worker registration error:", error);
    });
};